module.exports = __webpack_public_path__ + "assets/img/9506-gb-sct.svg";